<template>
  <div id='beforeQuestion'>
	  <plugin />
	  <Tabbar msg="/beforeQuestion" />
			<div class="notify" >
					<div class='title'>NUTRIPACKS</div>
          <div class='title'> <span>个性化</span>营养评估量表</div>
          <div class='line'></div>
					<div class='notifyTxtBox'>
                <div class='notifyTxt'>• 超过<span>100000</span>份营养数据支持</div>
                <div class='notifyTxt'>• 规避常见药物作用风险(<span>DNIs</span>)</div>
                <div class='notifyTxt'>• <span>5-10</span>分钟生成评估报告与方案</div>
          </div>
          <div class='btn' @click='toQuestions'>开始评估</div>
           <!-- <div v-if='is_record==1' class='app-btn app-btn-red btn' @click='keepQuestion' style='margin-bottom: 0.3rem;'>继续评估</div>
          <div v-if='is_record==1' class='app-btn app-btn-red btn' @click='toQuestions'>重新开始</div> -->
			</div>
  </div>
</template>


<script>
import Tabbar from '@/components/tabbar.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'beforeQuestion',
  components: {
		Tabbar,
		plugin
  },
  data:function () {
    return{
      is_record:2,     //是否有问卷记录，1有，2没有
      record_id:0,     //问卷记录id
      current_num:0,   //当前题目进度数量
    }
  },
  beforeCreate:function(options) {
     
  },
  created(){
this.checkQuestion()
	},
  mounted(){
    
  },
  methods: {
    toQuestions(){
		
		let _questions={
          is_up: 0,                 //是否查询上一题0不是，1是
          record_id: 0,             //问卷记录id，第一次请求为0
          question: [{              //请求下一题目数组,第一次请求写空数组
              question_id: 0,       //题目id
              answer_ids: [],       //用户选择的答案id组
              answer: ""            //非选择题答案，非选择题写空字符串
            }]
      }
	  
	   this.$store.commit("modifyQuestions",_questions)
       this.$router.push({name: 'Questions',
                          params: { record_id:0}
                        });
    },
    // 检查是否已有未完成问卷
    checkQuestion(){
      this.axios({
                  method: 'post',
                  url:"index/isQuestionRecord",
                  data:{
                     member_id:this.$store.state.member_id 
                  }
                }).then(res=>{
                      if(!res.data.data)return

                      this.is_record= res.data.data.is_record||2
                      this.record_id= res.data.data.record_id||0
                      this.current_num = res.data.data.current_num||0
                })
    },
    // 继续问卷
    keepQuestion(){
 
        this.$router.push({name: 'Questions',
                          params: { record_id:this.record_id}
                        });
    },


  }
} 
</script> 
<style>
#beforeQuestion{
  width: 7.5rem;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background-color: #F4F2F0;
  margin:0 auto;
}
#beforeQuestion .notify {
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%); 
    width: 5.74rem;
    min-height:8rem;
    box-sizing: border-box;
    padding: 0.93rem 0.87rem;
    text-align: center;
    border-radius:0.1rem;
    box-shadow: 0px 50px 50px -20px rgba(236, 163, 129, 0.288);
    background-color: #fff;
}

#beforeQuestion .title {
    font-size:0.4rem;
    font-family:SourceHanSansCN-Medium,SourceHanSansCN;
    font-weight:500;
    color:rgba(20,20,20,1);
    line-height:0.62rem;
    text-align: left;
}
#beforeQuestion .title span{
  color: rgba(183, 137, 117, 1);
}
#beforeQuestion .line{
  width:0.88rem;
  height:0.12rem;
  background:rgba(194,94,77,1);
  border-radius:0.09rem;
  margin:0.5rem 0;
}
#beforeQuestion .notifyTxtBox{
  margin-bottom: 1rem;
}
#beforeQuestion .notifyTxtBox .notifyTxt{
    font-size:0.24rem;
    font-family:SourceHanSansCN-Regular,SourceHanSansCN;
    font-weight:400;
    color:rgba(80,80,80,1);
    line-height:0.56rem;
    text-align: left;
}
#beforeQuestion .notifyTxtBox .notifyTxt span{
  font-weight: bold;
}
#beforeQuestion .btn{
  width: 4rem;
  border-radius:0.45rem;
  height:0.7rem;
  line-height: 0.7rem;
  box-sizing: border-box;
  padding: 0;
  border: none;
  color: #fff;
  font-weight: 500;
  font-size: 0.24rem;
  background-color: #C25E4D;
}
</style>